(function () {
  Flint.file('mframework/views/s3Uploader.js', function (require) {
    /*
      Props:
        onStartUpload: ({file}) => void
        onUploaded: ({s3Key}) => void
    */

    Flint.view('S3Uploader', function (view, on, $) {
      var pro = initPro(view, {
        accept: atom(),
        children: atom()
      });

      var uploading = atom(false);

      var handleFile = function handleFile(e) {
        var file = e.target.files[0];
        var s3Key = undefined;

        uploading.set(true);

        M.apiPost('signS3Upload', {
          params: {
            fileType: file.type
          }
        }).then(function (apiResponse) {
          s3Key = apiResponse.s3Key;
          var s3Url = '' + M.config.s3UrlPrefix + s3Key;

          return fetch(apiResponse.signedRequest, {
            method: 'put',
            headers: {
              'x-amz-acl': 'public-read'
            },
            body: file
          });
        }, function (err) {
          uploading.set(false);
          console.error("Error signing S3 upload:", err);
          M.util.alertError(err);
        }).then(function (s3Response) {
          uploading.set(false);

          if (view.props.onUploaded) {
            view.props.onUploaded({ s3Key: s3Key });
          }
        }, function (err) {
          uploading.set(false);
          console.error("Error uploading to S3:", err);
        });

        if (view.props.onStartUpload) {
          view.props.onStartUpload({ file: file });
        }
      };view.render(function () {
        return Flint.iff(!uploading.get()) && view.el(
          ['notUploading', 1],
          { if: !uploading.get() },
          view.el(
            ['Uploader', 1],
            { accept: pro.accept.get(), onChange: handleFile },
            pro.children.get()
          )
        );
      });view.render(function () {
        return Flint.iff(uploading.get()) && view.el(
          ['uploading', 1],
          { if: uploading.get() },
          pro.children.get()
        );
      });
    });
  })
})();
//# sourceMappingURL=s3Uploader.js.map
